import { call, put, takeEvery } from "redux-saga/effects";
import {
	ActionsCompleting,
	API_COMPLETING,
	failureCompleting,
	loadCompletingSuccess,
} from "./actions";

function* loadDataCompleting(params = {}) {

	try {

		const endpoint = API_COMPLETING;
		const { Authorization } = params.payload;
		const headers = params.payload.is_server
			? {
				...params.payload.headers,
				...(Authorization && { Authorization }),
			}
			: {
				...params.payload.headers,
				...(Authorization && { Authorization }),
			};
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (response.status >= 200 && response.status < 300) {

			const data = yield response.json();
			yield put(loadCompletingSuccess(data));

		}

	} catch (err) {

		yield put(failureCompleting(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsCompleting.GET_COMPLETING, loadDataCompleting);

}
